import { useQuery } from '@tanstack/react-query';
import { useRef } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { fetchKitchenById } from '../../services/catalog.api';
import MapBox from '../shared/Map';
import FoodSection from './FoodSection/FoodSection';
import KitchenDiscountCarousel from './KitchenDiscountCarousel/KitchenDiscountCarousel';
import KitchenProfile from './KitchenProfile/KitchenProfile';
import KitchenRecipeParents from './KitchenRecipeParents/KitchenRecipeParents';
import NearestKitchenSeller from './NearestKitchenSeller/NearestKitchenSeller';
import Reviews from './Review/Review';
import SellerTipsComponent from './SellerTipsComponent/SellerTipsComponent';

export default function KitchenProfilePage() {
  const { id: kitchenId } = useParams();
  const recipeRef = useRef(null);
  const reviewRef = useRef(null);
  const foodRef = useRef(null);
  const tipsRef = useRef(null);
  const showcaseRef = useRef(null);

  const { data, isPending, error } = useQuery({
    queryKey: ['kitchenProfile', kitchenId],
    queryFn: () => fetchKitchenById(kitchenId),
    enabled: !!kitchenId,
  })

  if (error) {
    toast.error(error?.message);
  }

  const onTypeClick = (type) => {
    if (type === 'Kitchen') window.scrollTo({ top: 0, behavior: 'smooth' });
    if (type === 'Recipe' && recipeRef.current) recipeRef.current.scrollIntoView({ behavior: 'smooth' });
    if (type === 'Food' && foodRef.current) foodRef.current.scrollIntoView({ behavior: 'smooth' });
    if (type === 'Offer' && foodRef.current) foodRef.current.scrollIntoView({ behavior: 'smooth' });
    if (type === 'Tips & Tricks' && tipsRef.current) tipsRef.current.scrollIntoView({ behavior: 'smooth' });
    if (type === 'Review' && reviewRef.current) reviewRef.current.scrollIntoView({ behavior: 'smooth' });
    if (type === 'Showcase' && showcaseRef.current) showcaseRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="page-navbar-space pb-5 pb-md-0">
      <KitchenProfile onTypeClick={onTypeClick} data={data} isPending={isPending} />
      <div ref={showcaseRef} style={{ scrollMarginTop: "120px" }}><SellerTipsComponent data={data} isPending={isPending} /></div>
      <KitchenDiscountCarousel kitchenId={kitchenId} />
      <div ref={reviewRef} style={{ scrollMarginTop: "120px" }}><Reviews kitchenId={kitchenId} /></div>
      <div ref={foodRef} style={{ scrollMarginTop: "120px" }}><FoodSection data={data} isPending={isPending} /></div>
      <div ref={recipeRef} style={{ scrollMarginTop: "120px" }}><KitchenRecipeParents kitchenId={kitchenId} /></div>
      <NearestKitchenSeller />
      <div className="home-content-shell" style={{ paddingTop: 16, marginBottom: 24 }}>
        {isPending ? (
          <Skeleton height={400} width="100%" borderRadius={12} />
        ) : (
          <MapBox
            latitude={data?.address?.lat}
            longitude={data?.address?.lng}
            locationName={data?.name}
            zoom={15}
            height={400}
            width="100%"
          />
        )}
      </div>
    </div>
  )
}